import { render, staticRenderFns } from "./OfficerGroupManage.vue?vue&type=template&id=b52b8188&"
import script from "./OfficerGroupManage.vue?vue&type=script&lang=js&"
export * from "./OfficerGroupManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports